<template>
    <div
        class="marketing-form-quick"
        :class="{'fixed-bottom-button': fixed}"
        :style="customStyle"
    >
        <form-item validateKey="isAgree">
            <privacy
                :isAgree.sync="isAgree"
                linkLeftTxt="我已阅读并同意"
                :linkRightTxt="privacyName"
                :linkTo="privacyLink"
                :linkConfig="privacyList"
                :showMulti="true"
                @update:isAgree="onAgreeChange" />
        </form-item>
        <div class="submit-but" :style="submitButtonStyle" @click="openModal">
            {{ submitButtonText }}
        </div>
        <div class="marketing-form-modal" v-if="showModal">
            <div class="marketing-form-modal-mask" @click="toggleModal" />
            <div class="marketing-form-modal-content">
                <span
                    v-if="!!formTitle"
                    class="close"
                    @click="toggleModal"
                ></span>
                <marketing-form
                    :isDemo="isDemo"
                    :trackName="trackName"
                    :series="series"
                    :formMode="formMode"
                    :lpConfig = "lpConfig"
                    :presetModel="presetModel"
                    :presetAreaCode="presetAreaCode"
                    :presetName="name"
                    :campaignCode="campaignCode"
                    :welfareId="welfareId"
                    :askingModal="askingModal"
                    :formTitle="formTitle"
                    :comment="comment"
                    :fields="fields"
                    :submitButtonText="submitButtonText"
                    :submitButtonStyle="submitButtonStyle"
                    :privacyName="privacyName"
                    :privacyLink="privacyLink"
                    :privacyList="privacyList"
                    :privacyAgreed.sync="isAgree"
                    :guideLink="guideLink"
                    :presetChannel="presetChannel"
                    :useGeoLocation="useGeoLocation"
                    
                    :needTrackExpose="false"
                    :componentId="componentId"
                    :positionRank="positionRank"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { stopBodyScroll } from '@/util/dom';
import formPropsMixin from '../mixin/form-props';
import formMixin from '@/mixin/form';
import Privacy from '@/marketing_components/form/privacy/index.vue'; // @/components/form/privacy/index.vue
import MarketingForm from './form.vue';
import { PAGE_MODE_MAP } from '@/config/enums';
import trackExposeMixin from '../mixin/track-expose';

const mixin = {
    computed: {
        ...mapState('marketing/', ['pageConfig', 'campaignOption'])
    }
};

export default {
    name: 'marketing-form-quick',
    componentName: 'marketingFormQuick',
    mixins: [mixin, formPropsMixin, formMixin(), trackExposeMixin],
    components: {
        Privacy,
        MarketingForm
    },
    props: {
        fixed: {
            type: Boolean,
            value: true
        }
    },
    data() {
        return {
            isAgree: false,
            showModal: false,
            name: '',
            formRules: {
                name: {
                    require: this.fields && this.fields.indexOf('name') >= 0,
                    message: '请输入姓名'
                },
                isAgree: {
                    require: true,
                    message: `请先阅读并同意${this.privacyName}`
                }
            }
        };
    },
    methods: {
        trackRetentionFlow(custom = {}) {
            if (!this.isDemo) {
                this.$tracker.collectPlus('RetentionFlow', {
                    campaign_code: this.campaignCode,
                    invite_account: this.campaignOption.accountId,
                    page: PAGE_MODE_MAP[this.formMode],
                    ...custom,
                    // 新属性
                    requirement_id: 1435,
                    track_sign: 'aCar.b1013.c1799.d1809.result.RetentionFlow',
                    link: window.location.href,
                    component_id: this.componentId,
                    mkt_type: this.trackName,
                    position_rank: this.positionRank,
                    fellow_emp_domain: this.campaignOption.fellowEmpDomain,
                    fellow_name: this.campaignOption.registerEmpDomain,
                    is_clickable: true
                });
            }
        },
        toggleModal() {
            stopBodyScroll(!this.showModal);
            this.showModal = !this.showModal;
        },
        openModal() {
            if (this.checkForm()) {
                this.toggleModal();
            }
        },
        onAgreeChange(checked) {
            if (checked) {
                this.trackRetentionFlow({
                    step_name: 'agree_privacy',
                    lp_id: this.lpConfig.lpId
                });
            }
        }
    },
    computed: {
        forcedDisplayName() {
            return this.fields && this.fields.indexOf('name') >= 0;
        }
    }
};
</script>

<style lang="less" scoped>
@import '~src/assets/css/mixin.less';
@import '~src/assets/css/variable.less';
.marketing-form-quick {
    display: flex;
    flex-direction: column;
    background: #ffffff;
    padding: 0 25 * @layout375;
    .submit-but {
        height: 45 * @layout375;
        margin-top: 16 * @layout375;
        margin-bottom: 15 * @layout375;
        font-size: 16 * @layout375;
        color: #ffffff;
        background: #00bcbc;
        border-radius: 25 * @layout375;
        position: relative;
        .center();
        &.disabled {
            background: #cdced4;
            color: #ffffff;
        }
    }
}
.marketing-form-modal {
    display: block;
    position: fixed;
    z-index: 1001;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.4);
    width: 100%;
    height: 100%;
    animation: 0.3s fadeIn;
}
.marketing-form-modal-mask {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
}
.marketing-form-modal-content {
    background: #fff;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    overflow: hidden;
    box-sizing: border-box;
    .close {
        position: absolute;
        right: 25 * @layout375;
        top: 20 * @layout375;
        z-index: 8;
        background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwBAMAAAClLOS0AAAAG1BMVEVHcExpbn9ibHpqbYBqbX5mZoBpbYBobH5pbX8ZklvmAAAACHRSTlMAnBbUWQq8fwUtPhEAAACnSURBVDjL5dNNCsMgEAVghfxsC9m4zBl6iJBlyRVCDtAjFDdz7BqR8Y2+E7SuHOWDmSc69xfrjcX20u0sj3o+yKV7L596scuzFqGSQeLqGDEAiAVAGqCkBUo6UEgPCiEgEwYyoeAmFNyEg9QShuwwVgwZQQyUpJY8I3kGRvIMhJShe1KG7oim1BJNqSEQqyUQqyHmHZBMGKuHYjzxHRYoDuzk+KmP/AVZBzZ2i29QLQAAAABJRU5ErkJggg==);
        background-repeat: no-repeat;
        background-size: cover;
        width: 20 * @layout375;
        height: 20 * @layout375;
    }
}
.marketing-form {
    display: block;
    width: 100%;
}
.fixed-bottom-button {
    border-top: 1 * @layout375 solid #f0f1f2;
    background: #ffffff;
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}
</style>




// WEBPACK FOOTER //
// src/views/marketing/components/quick.vue